import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../../core/core.module';
import { AppModuleGlobalShared } from '../../../../app.module.global';
import { PeriodosRoutingModule } from './periodos-routing.module';
import { PeriodoCamWrapperComponent } from './datosbasicos/periodo-wrapper/periodo-wrapper.component';
import { PeriodoCamListComponent } from './datosbasicos/periodo-list/periodo-list.component';
import { PeriodoFilterComponent } from './datosbasicos/periodo-filter/periodo-filter.component';
import { PeriodoCamWrapperEditComponent } from './datosbasicos/periodocam-wrapper-edit/periodocam-wrapper-edit.component';
import { PeriodoCamEditComponent } from './datosbasicos/periodocam-edit/periodocam-edit.component';
import { PeriodoCamService } from './datosbasicos/periodocam.service';
import { PeriodosVariedadListComponent } from './periodos-variedades/periodos-variedad-list/periodos-variedad-list.component';
import { PeriodosVariedadWrapperComponent } from './periodos-variedades/periodos-variedad-wrapper/periodos-variedad-wrapper.component';
import { PeriodosVariedadService } from './periodos-variedades/periodos-variedad.service';
import { EspeciesModule } from '../../especies/especies.module';
import { PeriodoAmbitoWrapperEditComponent } from './ambito/ambito-wrapper-edit/ambito-wrapper-edit.component';
import { PeriodoAmbitoEditComponent } from './ambito/ambito-edit/ambito-edit.component';
import { PeriodoAmbitoService } from './ambito/ambito.service';
import { PlazosWrapperComponent } from './plazos/plazos-wrapper/plazos-wrapper.component';
import { PlazosListComponent } from './plazos/plazos-list/plazos-list.component';
import { PeriodoPlazoService } from './plazos/plazos.service';
import { PlazosWrapperEditComponent } from './plazos/plazos-wrapper-edit/plazos-wrapper-edit.component';
import { PlazosEditComponent } from './plazos/plazos-edit/plazos-edit.component';
import { DatosCaListComponent } from './datosca/datosca-list/datosca-list.component';
import { DatosCaWrapperComponent } from './datosca/datosca-wrapper/datosca-wrapper.component';
import { PeriodoDatosCaService } from './datosca/datosca.service';
import { DatosCaEditComponent } from './datosca/datosca-edit/datosca-edit.component';
import { DatosCaWrapperEditComponent } from './datosca/datosca-wrapper-edit/datosca-wrapper-edit.component';
import { InspeccionesWrapperComponent } from './inspecciones/inspecciones-wrapper/inspecciones-wrapper.component';
import { InspeccionesListComponent } from './inspecciones/inspecciones-list/inspecciones-list.component';
import { PeriodoInspeccionService } from './inspecciones/inspecciones.service';
import { InspeccionesWrapperEditComponent } from './inspecciones/inspecciones-wrapper-edit/inspecciones-wrapper-edit.component';
import { InspeccionesEditComponent } from './inspecciones/inspecciones-edit/inspecciones-edit.component';

@NgModule({
    declarations: [
        PeriodoAmbitoWrapperEditComponent,
        PeriodoAmbitoEditComponent,
        PeriodosVariedadListComponent,
        PeriodosVariedadWrapperComponent,
        PlazosWrapperComponent,
        PlazosListComponent,
        PlazosWrapperEditComponent,
        PlazosEditComponent,
        InspeccionesWrapperComponent,
        InspeccionesListComponent,
        InspeccionesWrapperEditComponent,
        InspeccionesEditComponent,
        DatosCaListComponent,
        DatosCaWrapperComponent,
        DatosCaEditComponent,
        DatosCaWrapperEditComponent,
        PeriodoCamWrapperEditComponent,
        PeriodoCamEditComponent,
        PeriodoCamWrapperComponent,
        PeriodoCamListComponent,
        PeriodoFilterComponent,
    ],
    exports: [],
    imports: [CoreModule, AppModuleGlobalShared, CommonModule, FormsModule, ReactiveFormsModule, PeriodosRoutingModule, EspeciesModule], // Incorporamos el componente Variedad-Buscador],
    providers: [PeriodosVariedadService, PeriodoCamService, PeriodoAmbitoService, PeriodoPlazoService, PeriodoInspeccionService, PeriodoDatosCaService],
})
export class PeriodosModule {}
